export const APP_STORE_URL = "https://apps.apple.com/us/app/kuth%C3%A9/id6760719584";
export const ease = [0.25, 0.46, 0.45, 0.94];

/**
 * App Store link with campaign tags.
 * - utm_* for web/analytics continuity
 * - ct for App Store Connect campaign reporting (Apple may strip UTMs)
 */
export function appStoreUrl(campaign = "web") {
  const url = new URL(APP_STORE_URL);
  url.searchParams.set("mt", "8");
  url.searchParams.set("ct", campaign);
  url.searchParams.set("utm_source", "kuthe_web");
  url.searchParams.set("utm_medium", "app_store");
  url.searchParams.set("utm_campaign", campaign);
  return url.toString();
}

/** Public, clean shop URL. Share clicks are attributed by the GA event at the source. */
export function shopShareUrl(shopId) {
  return `https://kuthe.coffee/shop/${encodeURIComponent(shopId)}`;
}

export function collectionShareUrl(slug) {
  return `https://kuthe.coffee/collections/${encodeURIComponent(slug)}`;
}
